module.exports = __webpack_public_path__ + "img/gq.80b56bda.svg";